export const FUND_LIST = 'FUND_LIST'
export const FUND_DETAIL = 'FUND_DETAIL'
export const FUND_TRENDING_LIST = 'FUND_TRENDING_LIST'
export const FUND_TOP_HOLDINGS = 'FUND_TOP_HOLDINGS'
export const FUND_NAV = 'FUND_NAV'
export const FUND_NAV_VERIFY = 'FUND_NAV_VERIFY'
export const FUND_NAV_LATEST = 'FUND_NAV_LATEST'
export const FUND_PERIOD = 'FUND_PERIOD'
export const FUND_UNIT_TYPE = 'FUND_UNIT_TYPE'
export const FUND_RANKING = 'FUND_RANKING'
export const FUND_AMC = 'FUND_AMC'
export const FUND_CATEGORIES = 'FUND_CATEGORIES'
export const FUND_PAGINATION = 'FUND_PAGINATION'
export const FUND_FOLLOWING = 'FUND__FOLLOWING'